import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { LoginForm } from './LoginForm';
import { RegisterForm } from './RegisterForm';
import { useNavigate } from 'react-router-dom';

interface AuthFormProps {
  mode: 'login' | 'register';
  onModeChange: (mode: 'login' | 'register') => void;
  onSuccess: () => void;
}

export function AuthForm({ mode, onModeChange, onSuccess }: AuthFormProps) {
  return (
    <div className="space-y-6">
      <div className="flex flex-col space-y-2 text-center">
        <h1 className="text-2xl font-semibold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 to-indigo-700">
          {mode === 'login' ? 'Welcome Back' : 'Create Account'}
        </h1>
        <p className="text-sm text-muted-foreground">
          {mode === 'login' 
            ? 'Sign in to start creating exceptional content'
            : 'Sign up to start your content creation journey'
          }
        </p>
      </div>

      <div className="grid w-full grid-cols-2">
        <Button
          variant={mode === 'login' ? 'default' : 'ghost'}
          className="data-[state=active]:bg-indigo-50 data-[state=active]:text-indigo-700"
          onClick={() => onModeChange('login')}
        >
          Login
        </Button>
        <Button 
          variant={mode === 'register' ? 'default' : 'ghost'}
          className="data-[state=active]:bg-indigo-50 data-[state=active]:text-indigo-700"
          onClick={() => onModeChange('register')}
        >
          Sign Up
        </Button>
      </div>

      <div className="space-y-6">
        {mode === 'login' ? (
          <LoginForm onSuccess={onSuccess} />
        ) : (
          <RegisterForm />
        )}
      </div>
    </div>
  );
} 